const content  = {
    EN: {
      cardA: 'Products',
      cardB: 'Customer Balance',
      cardC: 'Collections'
    },
    GR: {
      cardA: 'Είδη',
      cardB: 'Υπόλοιπα πελατών',
      cardC: 'Collections'
    },
  };

  export default content;
  


// WEBPACK FOOTER //
// ./src/components/home/content.js